import { reportException } from '@comeon/error-reporter';
import { checkRegisterFieldUniqueCall } from '~/components/authentication/api';
import { ErrorReporterDomain } from '../../error-handling/error-reporter-domain';

export const isWEBOTPSupported = () => {
	return 'OTPCredential' in window && typeof AbortController !== 'undefined';
};

export const isFunction = (arg?: unknown): boolean => typeof arg === 'function';

export const checkRegisterFieldUnique = async (
	field: string,
	values: string[],
	guestFranchiseId: string | undefined
) => {
	try {
		const {
			status,
			errorCode = '',
			errorDescription
		} = (await checkRegisterFieldUniqueCall({
			field,
			values,
			guestFranchiseId
		})) as { status: 'SUCCESS' | 'FAILURE'; errorCode?: string; errorDescription?: string };

		return {
			unique: status === 'SUCCESS',
			errorCode,
			errorDescription
		};
	} catch (e) {
		reportException(e as Error, {
			domain: ErrorReporterDomain.AUTHENTICATION,
			extra: {
				type: 'phone-verification-error',
				info: values.join('-'),
				url: window.location
			}
		});
		return {
			unique: false,
			errorCode: 500
		};
	}
};

export const isAboveAgeLimit = ({ birthday, limit }: { birthday: Date; limit: number }) => {
	if (Object.prototype.toString.call(birthday) !== '[object Date]') {
		return false;
	}

	const today = new Date();
	const m = today.getMonth() - birthday.getMonth();
	let age = today.getFullYear() - birthday.getFullYear();

	if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
		age -= 1;
	}

	return age >= limit;
};
